import { useNovaApi } from '../useNovaApi';

export const useSongStats = () =>
  useNovaApi<Nl.Api.SongStatsResponse>('/song/stats');
